import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';

export const assurantRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);

  const currentURI = state.url;
  const replacedURI = currentURI.replace('/assurant', '/renters');

  router.navigateByUrl(replacedURI);

  return false;
};
